import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.input.select.singleEc.Component,
    ds.layout.page.Component,
    ds.layout.section.Component,
    ds.overlay.confirmation.Component,
    ds.overlay.slideout.Component,
    ds.table.Component,
  ],
  selector: 'atn-mapping-tab',
  standalone: true,
  styleUrls: ['./mapping-tab.component.scss'],
  templateUrl: './mapping-tab.component.html',
})
export class AtnMappingTabComponent {
  /** @see {@link state.rate.gl.EcInjector} */
  public readonly glEc = ngCore.inject(state.rate.gl.records.Collection)

  /**
   * @see {@link state.rate.gl.EcInjector.ec GlMappingEntry EntityCollection}
   */
  public readonly glMappingEntryEc = ngCore.inject(
    state.rate.gl.mappingEntries.Collection,
  )

  /** Canonical embedded table input for mapping entries. */
  public readonly tableConfig = {
    collection: this.glMappingEntryEc,
    view: { container: 'embedded' },
  } satisfies ds.table.ec.Config.Input<state.rate.gl.mappingEntries.TypeParams>

  /**
   * @see {@link state.rate.gl.EcInjector.ec Rule EntityCollection}
   */
  private readonly _ruleEc = ngCore.inject(state.rate.gl.rules.Collection)

  /** Adjustment label based on biggest priority applied rule  */
  public readonly adjustmentLabelSg = ngCore.computed(
    (
      gl = this.glEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
      rules = this._ruleEc.plugins.currentListPlugin.feature.selectors.entities.asSignal(),
    ) => {
      const appliedRuleIds =
        gl?.applicableRuleIds.map(id => id.toString()) ?? []

      const appliedRules = rules.filter(r =>
        appliedRuleIds.includes(r.id.toString()),
      )
      const [rule] = appliedRules.sort((a, b) => a.priority - b.priority)

      return rule?.mapping.adjustmentLabel ?? ''
    },
  )
}
